import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

interface RadioOption {
  label: string | JSX.Element;
  value: string;
}

interface MRadioProps {
  label?: string;
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  options: RadioOption[];
  disabled?: boolean;
}

function isHtml(str:any) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}

export const MRadio = (props: MRadioProps) => {
  const { label, value = null, onChange, options, disabled } = props;

  if (!options) return <></>;

  return (
    <>
      {/* {label && <InputLabel dangerouslySetInnerHTML={{ __html: label }}/>} */}
      {label && isHtml(label) ? (
    <InputLabel dangerouslySetInnerHTML={{ __html: label }} />
  ) : (
    <InputLabel>{label}</InputLabel>
  )}
      <FormControl>
        <RadioGroup
          value={value}
          onChange={onChange}
        >
          {options.map((option: RadioOption, key) => (
            <FormControlLabel key={key} 
                              value={option.value} 
                              control={<Radio 
                                sx={{ paddingY: 0.5 }} 
                                disabled={disabled} />} 
                                //label={option.label}
                                label={option.label}
                                />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
}

export default MRadio;
